export default __webpack_public_path__ + "static/media/youtube.f26bb03f.svg";